import PlainTextCell from 'components/PlainTextCell';

type Props = {
  rowData: {
    totals?: DeepPartial<Pick<NonNullable<SentinelTeam['totals']>, 'members'>>;
  };
};

export default function MembersCell({ rowData: { totals } }: Props) {
  return <PlainTextCell textAlign="end" topLine={totals?.members?.total} />;
}
